import { EngageStore } from '../domain/DomainLayer'
import { initializeFirebase } from './firebase'
import { initializeAxios } from './services'

export function initializeDataLayer(store: EngageStore) {
  initializeAxios(store)
  initializeFirebase(store)
}
